import { Flex, Typography } from "antd"
import React from "react"
import { Outlet } from "react-router-dom"

import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import SettingsLayoutTabs from "./SettingsLayoutTabs.tsx"

const { Title } = Typography

export function SettingsLayout() {
  const moduleAccess = useAppSelector(
    (state) => state?.auth?.userInfo?.permissions?.codes
  )

  return (
    <Flex vertical gap={"middle"} className={"size-full -mt-2"}>
      <div className={"sticky top-16 bg-background z-10 pt-2"}>
        <Flex justify={"space-between"}>
          <Title className={"text-start"} level={2}>
            Settings
          </Title>
        </Flex>
        <SettingsLayoutTabs permissions={moduleAccess} />
      </div>
      <Flex flex={1}>
        <Outlet />
      </Flex>
    </Flex>
  )
}
